import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    IconButton
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Close } from '@mui/icons-material';

const StockConfirmationDialog = ({
    open,
    onClose,
    shortages,
    onProceedWithAvailable,
    onPurchaseRemaining,
    loading
}) => {
    // Check if any shortage has available quantity > 0
    const hasAvailableStock = shortages?.some(shortage => shortage?.available > 0);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 3 }}>
                <DialogTitle>
                    <Typography variant="h3">Insufficient Stock</Typography>
                </DialogTitle>
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </Box>

            <DialogContent>
                <TableContainer component={Paper} sx={{ mb: 2 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong>Material</strong></TableCell>
                                <TableCell align="center"><strong>Requested</strong></TableCell>
                                <TableCell align="center"><strong>Available</strong></TableCell>
                                <TableCell align="center"><strong>Need to Purchase</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {shortages?.map((shortage, index) => (
                                <TableRow key={index}>
                                    <TableCell>{shortage?.material?.name || 'Unknown'}</TableCell>
                                    <TableCell align="center">
                                        <Chip
                                            label={shortage?.requested}
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Chip
                                            label={shortage?.available}
                                            size="small"
                                            color="success"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Chip
                                            label={shortage?.needsToPurchase}
                                            size="small"
                                            color="error"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Buttons inside DialogContent to align with table width */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: hasAvailableStock ? 'space-between' : 'flex-end',
                        alignItems: 'center',
                        mt: 4,
                        width: '100%'
                    }}
                >
                    {hasAvailableStock && (
                        <Button
                            onClick={onProceedWithAvailable}
                            variant="contained"
                            color="success"
                            disabled={loading}
                        >
                            Proceed with Available Quantity
                        </Button>
                    )}

                    <Button
                        onClick={onPurchaseRemaining}
                        variant="contained"
                        color="primary"
                        disabled={loading}
                    >
                        Purchase Remaining Quantity
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default StockConfirmationDialog;